import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Header from "../../Components/Header/Header";
import {
  GetCustomerMemberShip,
  getQRDetailsApiCall,
} from "../../network/Network";

const CheckDetails = () => {
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(null);
  let params = new URLSearchParams(window.location.search);
  const getQRDetailsFunc = () => {
    let sendData = {
      id: params.get("id"),
    };
    getQRDetailsApiCall(sendData)
      .then((res) => {
        setState(res?.data?.response?.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    getQRDetailsFunc();
  }, []);
  return (
    <div className="CheckDetails">
      {/* <Header /> */}
      <div className="container">
        <div className="row mt-5">
          <div className="col-lg-12 text-center">
            <h2 className="">Your membership booking details</h2>
          </div>
          {loading ? (
            <Skeleton count={8} />
          ) : (
            <>
              {state
                ?.filter((item) => {
                  if (item?.membership?.type == "csa") {
                    return item;
                  }
                })
                .map((item) => {
                  return item;
                }) ? (
                <>
                  <div className="col-lg-12">
                    <h3 className="mt-3">Family Membership</h3>
                  </div>
                  {state?.map((item, index) => {
                    if (
                      item?.membership?.type !== "csa" &&
                      item?.family_members?.length > 0
                    ) {
                      return (
                        <div key={index} className="col-lg-6 family-membership">
                          <div className="card mt-3">
                            <div className="card-body">
                              <p>Date: {item?.updated_at.slice(0, 10)}</p>
                              <p>
                                Subscription Status:{" "}
                                {/* {item?.subscription_status.replaceAll("_", " ")} */}
                                {item?.subscription_status}
                              </p>
                              <b>Family Member Details:</b>
                              <div className="row mt-3">
                                {item?.family_members.map(
                                  (family_item, index) => {
                                    return (
                                      <>
                                        <div>
                                          <b>Family Member: {index + 1}</b>
                                        </div>
                                        <div className="col-lg-4">
                                          <p>
                                            <b>Name </b>
                                          </p>
                                        </div>
                                        <div className="col-lg-8">
                                          <p>{family_item?.full_name}</p>
                                        </div>
                                        <div className="col-lg-4">
                                          <p>
                                            <b>Email </b>
                                          </p>
                                        </div>
                                        <div className="col-lg-8">
                                          <p>{family_item?.email}</p>
                                        </div>
                                        <div className="col-lg-4">
                                          <p>
                                            <b>Age </b>
                                          </p>
                                        </div>
                                        <div className="col-lg-8">
                                          <p>{family_item?.age}</p>
                                        </div>
                                        <div className="col-lg-4">
                                          <p>
                                            <b>Gender </b>
                                          </p>
                                        </div>
                                        <div className="col-lg-8">
                                          <p>{family_item?.gender}</p>
                                        </div>
                                        <div className="col-lg-4">
                                          <p>
                                            <b>Contact </b>
                                          </p>
                                        </div>
                                        <div className="col-lg-8">
                                          <p>{family_item?.contact}</p>
                                        </div>
                                        <div className="col-lg-4">
                                          <p>
                                            <b>Address </b>
                                          </p>
                                        </div>
                                        <div className="col-lg-8">
                                          <p>{family_item?.address}</p>
                                        </div>
                                      </>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </>
              ) : null}

              {state
                ?.filter((item) => {
                  if (item?.membership?.type == "csa") {
                    return item;
                  }
                })
                .map((item) => {
                  return item;
                }) ? (
                <>
                  <div className="col-lg-12">
                    <h3 className="mt-3">CSA Membership</h3>
                  </div>
                  {state?.map((item, index) => {
                    if (item?.membership?.type == "csa") {
                      return (
                        <div key={index + 4894} className="col-lg-6">
                          <div className="card mt-3">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-lg-6">
                                  <p>
                                    <b>Date:</b>{" "}
                                  </p>
                                </div>
                                <div className="col-lg-6">
                                  <p> {item?.updated_at.slice(0, 10)}</p>
                                </div>
                                <div className="col-lg-6">
                                  <p>
                                    <b>Subscription Status:</b>
                                  </p>
                                </div>
                                <div className="col-lg-6">
                                  <p>
                                    {" "}
                                    {/* {item?.subscription_status.replaceAll(
                                      "_",
                                      " "
                                    )} */}
                                    {item?.subscription_status}
                                  </p>
                                </div>
                                <div className="col-lg-6">
                                  <p>
                                    <b>CSA Product description:</b>{" "}
                                  </p>
                                </div>
                                <div className="col-lg-6">
                                  <p>{item?.csa_product?.description}</p>
                                </div>
                                <div className="col-lg-6">
                                  <p>
                                    <b>Membership Renewal:</b>{" "}
                                  </p>
                                </div>
                                <div className="col-lg-6">
                                  <p>{item?.csa_product_price?.type}</p>
                                </div>
                                <div className="col-lg-6">
                                  <p>
                                    <b>Product Name:</b>{" "}
                                  </p>
                                </div>
                                <div className="col-lg-6">
                                  <p>{item?.csa_product?.title}</p>
                                </div>
                                <div className="col-lg-6">
                                  <p>
                                    <b>Product Price:</b>{" "}
                                  </p>
                                </div>
                                <div className="col-lg-6">
                                  <p>{item?.csa_product_price?.price}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckDetails;
